import { useState } from 'react';
import { ImageOff, LoaderCircle } from 'lucide-react';

export const ProductPreviewImage = ({src, name, testId}) => {
  const [failedSrc,setFailedSrc] = useState(null);
  const failed = src === null || (src && failedSrc === src);
  if (src && !failed) return <img src={src} alt={`${name} rendered product preview`} data-testid={testId} data-preview-kind="product-render" draggable={false} onError={()=>setFailedSrc(src)}/>;
  return <span className="product-preview-placeholder" data-testid={`${testId}-${failed?'unavailable':'loading'}`} role="status" aria-label={failed?`${name} preview unavailable`:`Loading ${name} product preview`}>
    {failed ? <ImageOff size={20} aria-hidden="true"/> : <LoaderCircle size={18} className="product-preview-spinner" aria-hidden="true"/>}
  </span>;
};